import type { RouteRecordRaw } from 'vue-router';

/**
 * Rotas para o módulo de simulação
 */
export const simulationRoutes: RouteRecordRaw[] = [
  {
    name: 'SimpleRealEstateSimulation',
    path: 'realty/simple',
    component: () => import('@/views/private/simulations/realty/simple.vue'),
  },
  {
    name: 'DeadlinesRealEstateSimulation',
    path: 'realty/deadlines',
    component: () => import('@/views/private/simulations/realty/deadlines.vue'),
  },
  {
    name: 'BanksRealEstateSimulation',
    path: 'realty/banks',
    component: () => import('@/views/private/simulations/realty/banks.vue'),
  },
  {
    name: 'DetailedRealEstateSimulation',
    path: 'realty/detailed',
    component: () => import('@/views/private/simulations/realty/detailed.vue'),
  },
  {
    name: 'BestMatchRealEstateSimulation',
    path: 'realty/bestMatch',
    component: () => import('@/views/private/simulations/realty/BestMatch.vue'),
  },
];
